import { render, staticRenderFns } from "./SupplierReturnMatrixFilters.vue?vue&type=template&id=10ff3137&"
import script from "./SupplierReturnMatrixFilters.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnMatrixFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports